import { PropsWithChildren } from "react"

import { useApiMutation } from "../../../../../../core/api/useApiMutation"
import { CreateBillReceiverDialogCore } from "../../../../billReceivers/dialog/CreateBillReceiverDialogCore"
import { fetchBillReceiversMS } from "../../../createOrderApi"
import { BillReceiversItemMS } from "../../../createOrderTypes"

import { AddBillReceiverMS } from "./AddBillReceiverMS"
import {
    BillReceiversFormValuesType,
    BillReceiversType,
    SendInvoiceCompany,
} from "../../../../billReceivers/billReceiverTypes"

type CreateBillDialogMSProps = Readonly<
    PropsWithChildren<{
        open: boolean
        onClose: () => void
        title: string
        onSimpleSelect?: (billReceiver: BillReceiversItemMS) => void
        onSelectBillReceiver: (
            billReceiver:
                | BillReceiversFormValuesType & {
                      type: BillReceiversType | null
                      search?: string
                      companySendInvoice?: SendInvoiceCompany
                  },
        ) => Promise<void>
        userId: number
    }>
>

export function CreateBillDialogMS({
    open,
    onClose,
    title,
    onSelectBillReceiver,
    onSimpleSelect,
    userId,
}: CreateBillDialogMSProps) {
    const { mutateAsync: searchBillReceivers, isLoading: isSearching } = useApiMutation(fetchBillReceiversMS, {})

    return (
        <CreateBillReceiverDialogCore<BillReceiversItemMS>
            open={open}
            onClose={onClose}
            title={title}
            disableBackdropClick
            closeOnSubmit={false}
            onSimpleSelect={onSimpleSelect}
            onSelectBillReceiver={onSelectBillReceiver}
            onSearch={async ({ search }) => {
                const res = await searchBillReceivers({ userId, endpoint: search })
                return { exists: Boolean(res.billReceivers?.length) }
            }}
            isSearching={isSearching}
            renderAddBillReceiverDialog={({ open: modalOpen, setOpen, type, searchText, onChoose, onCreateNew }) => (
                <AddBillReceiverMS
                    type={type}
                    searchText={searchText}
                    userId={userId}
                    dialogState={modalOpen}
                    setDialogState={setOpen}
                    handleChooseBillReceiver={onChoose}
                    handleCreateNewBill={onCreateNew}
                />
            )}
        />
    )
}
